import { api } from '@/api/api';

import { segment } from './modules/segment/segment';
import { campaign } from './modules/campaign';
import { domain } from './modules/domain';
import { schema } from './modules/schema';
import { exports } from './modules/exports';

export const company = {
  namespaced: true,
  modules: {
    segment,
    campaign,
    domain,
    schema,
    exports,
  },
  state: {
    cacheBuster: 1,
    fetchingList: true,
    changingCompany: false,
    list: [],
    currentId: -1,
    fetchingParameterNames: false,
    parameterNames: {},
  },
  getters: {
    noCompanies(state) {
      return state.list.length === 0;
    },
    currentCompany(state) {
      return state.list.find((company) => company.id === state.currentId) || {};
    },
  },
  mutations: {
    setFetching(state, fetching) {
      state.fetchingList = fetching;
    },
    setChangingCompany(state, changing) {
      state.changingCompany = changing;
    },
    setCompanies(state, companies) {
      state.list = companies;
    },
    updateCompany(state, company) {
      state.cacheBuster++;
      state.list = state.list.map((c) => {
        if (c.id === company.id) {
          return company;
        }
        return c;
      });
    },
    setCurrentCompany(state, companyId) {
      state.currentId = companyId;
    },
    setFetchingParameterNames(state, fetching) {
      state.fetchingParameterNames = fetching;
    },
    setParameterNames(state, parameterNames) {
      state.parameterNames = parameterNames;
    },
    addCompany(state, company) {
      state.list.push(company);
    },
  },
  actions: {
    async fetchCompanies({ commit, dispatch }) {
      commit('setFetching', true);
      const { data } = await api.get('companies/');
      commit('setCompanies', data);
      commit('setFetching', false);
      if (data.length > 0) {
        let toCompany = data[0].id;
        const lastCompany = window.localStorage.getItem('lastCompany');
        if (lastCompany) {
          const exists = data.find(
            (segment) => segment.id === Number(lastCompany)
          );
          if (exists) {
            toCompany = Number(lastCompany);
          }
        }
        dispatch('changeCompany', toCompany);
      } else {
        this.$router.push({ name: 'company-create' });
      }
    },
    async fetchParameterNames({ state, commit }) {
      commit('setFetchingParameterNames', true);
      const { data } = await api.get(
        `companies/${state.currentId}/display_name_mapping/`
      );
      commit('setParameterNames', data);
      commit('setFetchingParameterNames', false);
    },
    async updateParameterName({ state, commit }, name) {
      const { data } = await api.patch(
        `companies/${state.currentId}/display_name_mapping/`,
        {
          ...state.parameterNames,
          ...name,
        }
      );
      commit('setParameterNames', data);
    },
    async updateCompany({ state, commit }, { company, progress }) {
      const { data } = await api.patch(
        `companies/${state.currentId}/`,
        company,
        {
          headers: { 'Content-Type': 'multipart/form-data' },
          onUploadProgress: (event) =>
            progress && progress((event.loaded / event.total) * 100),
        }
      );
      commit('updateCompany', data);
    },
    async changeCompany({ commit, dispatch }, companyId) {
      window.localStorage.setItem('lastCompany', companyId);
      commit('setCurrentCompany', companyId);
      commit('setChangingCompany', true);
      await Promise.all([
        dispatch('segment/fetchSegments'),
        dispatch('campaign/fetchCampaigns'),
        dispatch('domain/fetchDomains'),
        dispatch('schema/fetchSchemas'),
        dispatch('fetchParameterNames'),
      ]);
      commit('setChangingCompany', false);
    },
  },
};
